export default __webpack_public_path__ + "static/eth-plugin-9828401709670ec6145e9aa54b0689cc.png";